const SESSION_COUNT_KEY = 'sessionCount';

function parseSessionCount(raw: string | null): number | null {
	if (raw == null || !/^\d+$/.test(raw)) return null;

	const value = Number(raw);
	if (!Number.isInteger(value) || value < 1) return null;

	return value;
}

/** Текущий номер сессии. Если ключа нет или он битый — записывает 1. */
export function readSessionCount(): number {
	const parsed = parseSessionCount(localStorage.getItem(SESSION_COUNT_KEY));
	if (parsed != null) return parsed;

	localStorage.setItem(SESSION_COUNT_KEY, '1');
	return 1;
}

/** Разлогин, протухший токен, 401 и смена аккаунта. */
export function incrementSessionCount(): number {
	const next = readSessionCount() + 1;
	localStorage.setItem(SESSION_COUNT_KEY, String(next));
	return next;
}

/** Первый вход записывает 1. Повторный вход увеличивает счётчик. */
export function noteLoginSession(): number {
	if (parseSessionCount(localStorage.getItem(SESSION_COUNT_KEY)) == null) {
		localStorage.setItem(SESSION_COUNT_KEY, '1');
		return 1;
	}

	return incrementSessionCount();
}
